/** 接口管理：列表展示模式 */
export const EXTERNAL_API_VIEW_MODE = Object.freeze({
  JSON: 'json',
  FORM: 'form',
})

/** 单条接口记录的编辑模式（与 view mode 一致） */
export const EXTERNAL_API_MODE = EXTERNAL_API_VIEW_MODE

export const HTTP_METHODS = Object.freeze(['GET', 'POST'])

export const DEFAULT_INTERFACE_JSON = Object.freeze({
  method: 'POST',
  url: '',
  body: {},
  contentType: 'application/json',
})

export const EXTERNAL_API_DESCRIPTION_MAX = 2000

export const EXTERNAL_API_JSON_MAX_LENGTH = 50000

/** Header 值常用选项 */
export const HEADER_VALUE_OPTIONS = Object.freeze([
  'application/json',
  'application/x-www-form-urlencoded',
  'text/plain',
])
